export default __webpack_public_path__ + "static/media/Group 24445.7600c88d.png";